;(function() {
  'use strict'

  var dependencies = ['ui.router', 'glow.resources', 'glow.services']

  angular.module('core.services', dependencies)

  // --------------------
})()
